import { BORDER_RADIUS_SMALL, FONTS, TYPOGRAPHY } from '@/styles';

import i18n from '@/utils/i18n';
import React, { useRef, useState } from 'react';
import { ActionSheetContent } from './action-sheet';
import { TextInput as BaseTextInput, StyleSheet } from 'react-native';
import { TextInput } from './text-input';

interface Props {
  initialBatchName: string;
  onClose: (name: string) => void;
}

export const TagPrintBatchRenameInput: React.FC<Props> = ({
  initialBatchName,
  onClose,
}) => {
  const inputRef = useRef<BaseTextInput>(null);
  const [batchName, setBatchName] = useState(initialBatchName);

  return (
    <ActionSheetContent
      actions={[i18n.t('save')]}
      disabledIndices={batchName ? undefined : [0]}
      message={
        <TextInput
          autoFocus
          clearButtonMode="while-editing"
          containerStyle={styles.renameTextInput}
          inputRef={inputRef}
          // Always focus since scan input in background also attempts to gain focus
          onBlur={inputRef.current?.focus}
          onChangeText={setBatchName}
          value={batchName}
        />
      }
      onAction={() => onClose(batchName)}
      title={i18n.t('rename_batch')}
      titleStyle={[
        TYPOGRAPHY.navigationTitle,
        FONTS.primarySemiBold,
        styles.contentTitle,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  contentTitle: {
    textAlign: 'left',
  },
  renameTextInput: {
    borderRadius: BORDER_RADIUS_SMALL,
    height: 48,
    marginBottom: 24,
    marginTop: 8,
  },
});
